import Route from "@ember/routing/route";
import { restartableTask, timeout } from "ember-concurrency";
import ENV from "glesys-controlpanel/config/environment";

export default class PrivateNetworksOverviewRoute extends Route {
  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  async model() {
    let { project } = this.modelFor("organization");
    let privateNetworks = await project.get("privateNetworks");

    return {
      privateNetworks,
      project,
    };
  }

  setupController(controller, model) {
    super.setupController(...arguments);
    this.pollStatusLoop.perform(model.privateNetworks);
  }

  resetController() {
    super.resetController(...arguments);
    this.pollStatusLoop.cancelAll();
  }

  // istanbul ignore next
  pollStatusLoop = restartableTask(async (privateNetworks) => {
    if (ENV.environment === "test") {
      return;
    }

    while (true) {
      await timeout(privateNetworks.some((privateNetwork) => privateNetwork.status !== "READY") ? 5 * 1000 : 60 * 1000);
      await privateNetworks.reload();
    }
  });
}
